/**
 * Returns the location of the sounds. On Web it resolves to an absolute path to
 * the sounds folder placed in the source root so it works across documents and windows.
 *
 * @returns {string}
 */
export function getSoundsPath() {
    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/sounds`;
    }

    return 'sounds';
}
